// api
import type { Building, Ticket, Topic } from '@/api/generated/daluxfm/daluxfm';

// relative
import type {
  DaluxBuildingOption,
  DaluxTicketFormValues,
  DaluxTopicOption,
} from './daluxTicketForm.schema';

type DaluxTicketFormMapperArgs = {
  ticket?: Ticket;
  reporterEmail?: string | null;
  buildingId?: string | null;
  topicId?: string | null;
};

export function toDaluxTicketFormValues({
  ticket,
  reporterEmail = '',
  buildingId,
  topicId,
}: DaluxTicketFormMapperArgs = {}): DaluxTicketFormValues {
  const defaultBuildingId =
    ticket?.data?.placement?.buildingRefs?.[0]?.buildingId ??
    buildingId ??
    null;
  const defaultTopicId = ticket?.data?.topic?.topicId ?? topicId ?? null;

  return {
    description: ticket?.data?.description ?? '',
    reporterName: ticket?.data?.reporterName ?? '',
    reporterEmail: ticket?.data?.reporterEmail ?? reporterEmail ?? '',
    photo: null,
    topicId: defaultTopicId,
    buildingId: defaultBuildingId,
  };
}

export function toDaluxTicketPayload(values: DaluxTicketFormValues): Ticket {
  return {
    data: {
      description: values.description.trim(),
      reporterName: values.reporterName.trim() || undefined,
      reporterEmail: values.reporterEmail || undefined,
      topic: values.topicId
        ? {
            topicId: values.topicId,
          }
        : undefined,
      placement: values.buildingId
        ? {
            buildingRefs: [
              {
                buildingId: values.buildingId,
              },
            ],
          }
        : undefined,
    },
  };
}

export function isDaluxBuildingOption(
  building: Building,
): building is DaluxBuildingOption {
  return Boolean(building);
}

export function isDaluxTopicOption(topic: Topic): topic is DaluxTopicOption {
  return Boolean(topic);
}
